import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer/footer";
import { useNavigate } from "react-router";
import performRequest from "../api/request";
import { Toast } from "../CustomComponent/toast";
import { useSelector } from "react-redux";

const TestResults = ({
  answer,
  test,
  totalMarks,
  testScheduleId,
  id,
  traineeTest,
}) => {
  const store = useSelector((store) => store?.login?.user);
  const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0);
  const [totalWrongAnswers, setTotalWrongAnswers] = useState(0);
  const [incorrectAnswersList, setIncorrectAnswersList] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [percentage, setPercentage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (traineeTest === "traineeTest") {
      let data = {
        answer,
        userId: store?.UserId,
        totalMarks,
        testScheduleId,
        test,
      };
      performRequest("POST", `test/trainee-test-result/`, data)
        .then((res) => {
          if (res?.status === 200) {
            setTotalCorrectAnswers(res?.data?.totalCorrect);
            setTotalWrongAnswers(
              res?.data?.totalQuestions - res?.data?.totalCorrect
            );
            setIncorrectAnswersList(res?.data?.results);
            setRemarks(res?.data?.remark);
            setPercentage(res?.data?.percentage);
            Toast("Test added to resume successfully", "success");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("Error adding test to resume", "error");
        });
    } else {
      let data = { answer, userId: store?.UserId, totalMarks, testScheduleId };
      performRequest("POST", `test/test-result/`, data)
        .then((res) => {
          if (res?.status === 200) {
            setTotalCorrectAnswers(res?.data?.totalCorrect);
            setTotalWrongAnswers(
              res?.data?.totalQuestions - res?.data?.totalCorrect
            );
            setIncorrectAnswersList(res?.data?.results);
            setRemarks(res?.data?.remark);
            setPercentage(res?.data?.percentage);
            Toast("Test added to resume successfully", "success");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("Error adding test to resume", "error");
        });
    }
  }, []);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xxl">
            <div className="section-header">
              <h2 className="section-title section-title-lg m-0 p-0">
                CURRENT TEST :
              </h2>
              <p className="section-description mb-4 p-0">
                Only pass results will be displayed on your profile.
              </p>
            </div>
            <div className="row row-cards">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row row-deck text-center ">
                      <div className="col-4">
                        <div className="card p-3">
                          <p>YOUR RESULT</p>
                          <h2 className="fs-3">
                            {/* {totalCorrectAnswers <= totalMarks
                              ? "PASS"
                              : "FAIL"} */}
                            {remarks}
                          </h2>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="card p-3">
                          <p>CORRECT ANSWERS</p>
                          <h2 className="fs-1">{totalCorrectAnswers}</h2>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="card p-3">
                          <p>WRONG ANSWERS</p>
                          <h2 className="fs-1">{totalWrongAnswers}</h2>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        onClick={() =>
                          navigate(`/employee-test-overview/${id}`)
                        }
                        className="btn btn-primary w-20 my-4 me-2"
                      >
                        View Profile
                      </button>
                      <button
                        onClick={() => navigate(`/my-scoreboard`)}
                        className="btn btn-primary w-20 my-4 ms-2"
                      >
                        View Leaderboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-sm mx-auto my-4">
                <div className="card-header bg-light">
                  <h5 className="card-title mb-0 fw-semibold text-muted">
                    📝 Mistakes Found
                  </h5>
                </div>

                <div className="card-body p-0">
                  {incorrectAnswersList?.length > 0 ? (
                    incorrectAnswersList?.map((item, index) => (
                      <div
                        key={item?.id}
                        className={`border-bottom p-4 ${
                          index % 2 === 0 ? "bg-light" : ""
                        }`}
                      >
                        {/* Question */}
                        <div className="alert alert-danger mb-3">
                          <strong>❌ Question: {item.question}</strong>
                        </div>

                        {/* Correct Answer */}
                        <div className="alert alert-info mb-2">
                          <strong>✅ Correct Answer:</strong>{" "}
                          {item?.correctAnswer}
                        </div>

                        {/* Given Answer */}
                        <div className="text-muted small">
                          Your answer:{" "}
                          <span className="text-danger fw-semibold">
                            {item?.givenAnswerLabel}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center p-5">
                      <div className="display-4 mb-3">🎉</div>
                      <h5 className="text-success mb-2">Perfect Score!</h5>
                      <p className="text-muted mb-0">
                        No incorrect answers found.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default TestResults;
